import { FrequentlyAskedQuestion } from './view';
export default FrequentlyAskedQuestion;
